import {QueryStatus, useInfiniteQuery} from '@tanstack/react-query'
import {
  PoliciesItemsTypes,
  PoliciesListReactQueryResponse,
  PoliciesListResponseType,
  SliceStatus,
} from 'interfaces'
import {PoliciesService, queryClient} from 'services'

interface UsePoliciesQueryResultType {
  fetchNextPage: () => void
  hasNextPage?: boolean
  status: SliceStatus | QueryStatus
  policies?: PoliciesItemsTypes[]
}

export const usePoliciesQuery = (): UsePoliciesQueryResultType => {
  const {
    data: policiesListResponse,
    fetchNextPage,
    hasNextPage,
    status,
  } = useInfiniteQuery({
    queryKey: ['getPolicies'],
    queryFn: ({pageParam = {}}) =>
      PoliciesService.getPolicies({LastEvaluatedKey: pageParam}),
    getNextPageParam: lastPage => lastPage?.data?.body?.LastEvaluatedKey,
  })

  const policies = policiesListResponse?.pages.flatMap(
    res => res?.data?.body?.Items,
  )

  return {
    fetchNextPage,
    hasNextPage,
    status,
    policies,
  }
}

export const getPoliciesList = () => {
  // Not used useQuery/useInfiniteQuery here, it was calling multiple API call, as using policy list from cache is enough here
  const policiesData = queryClient.getQueryData<PoliciesListReactQueryResponse>(
    ['getPolicies'],
  )

  const policies = policiesData?.pages?.flatMap(
    (res: PoliciesListResponseType) => res?.data?.body?.Items,
  )

  return policies || []
}
